<!-- <div class="directionLtr" style="padding: 0 15px 15px;">
  <div class="directionLtr" #chartDiv [id]="name" [ngStyle]="{'height': height, 'width': '100%', 'border' : isBorder ? '1px solid var(--color-border-secondary)' : 'none'}"></div>
</div> -->

<div class="directionLtr compareable_chart_container" style="padding: 0 15px 15px;">

  <!-- Reset icon -->
  <div class="dashboard-header">
    <div *ngIf="hasExpandedYears"
         (click)="resetExpandedYears()"
         class="reset-icon-overlap"
         [matTooltip]="'reports.collapse_all' | translate"
         matTooltipPosition="before">
      <img src="../../../../../assets/images/tabler-icon-rotate-clockwise.svg"
           alt="Collapse All"
           class="reset-img">
    </div>
  </div>

  <!-- Chart -->
  <div class="directionLtr"#chartDiv [id]="name" [ngStyle]="{ 'height': height, 'width': '100%', 'border' : isBorder ? '1px solid var(--color-border-secondary)' : 'none'}">
  </div>

</div>
